import SubmissionService from '../../services/SubmissionService.js'

export const namespaced = true

export const state = {
  submissions: [],
  submission: {}
}

export const mutations = {
  ADD_SUBMISSION(state, submission) {
    state.submissions.push(submission)
  },
  SET_SUBMISSIONS(state, submissions) {
    state.submissions = submissions
  },
  SET_SUBMISSION(state, submission) {
    state.submission = submission
  },
  UPDATE_SUBMISSION(state, submission) {
    state.submissions = [
      ...state.submissions.filter(s => s.submissionID !== submission.submissionID),
      submission
    ]
  },
  DELETE_SUBMISSION(state, id) {
    state.submissions = [
      ...state.submissions.filter(s => s.submissionID !== id)
    ]
  }
}

export const actions = {
  get({ commit }, id) {
    return new Promise((resolve, reject) => {
      const sub = state.submissions.find(s => s.submissionID == id)
      if (!sub) return reject()
      commit('SET_SUBMISSION', sub)
      resolve(sub)
    })
  },
  getSubmissions({ commit }) {
    return SubmissionService.getSubmissions().then(res => {
      commit('SET_SUBMISSIONS', res.data)
    })
  },
  save({ commit }, submission) {
    if (submission.submissionID) {
      return SubmissionService.put(submission).then(res => {
        const s = res.data
        commit('UPDATE_SUBMISSION', s)
        commit('SET_SUBMISSION', s)
      })
    } else {
      return SubmissionService.post(submission).then(res => {
        const s = res.data
        commit('ADD_SUBMISSION', s)
        commit('SET_SUBMISSION', s)
      })
    }
  },
  update({ commit }, submission) {
    return new Promise(resolve => {
      commit('UPDATE_SUBMISSION', submission)
      resolve(submission)
    })
  },
  set({ commit }, id) {
    return new Promise((resolve, reject) => {
      const sub = state.submissions.find(s => s.submissionID == id)
      if (!sub) return reject()
      commit('SET_SUBMISSION', sub)
      resolve(sub)
    })
  },
  delete({ commit }, id) {
    return SubmissionService.delete(id).then(() => {
      commit('DELETE_SUBMISSION', id)
    })
  },
  getFull({ commit, dispatch }, id) {
    return SubmissionService.getFull(id).then(res => {
      commit('SET_SUBMISSION', res.data.submission)
      return Promise.all([
        dispatch('change/setChanges', res.data.changes, { root: true }),
        dispatch('entity/setEntities', res.data.entities, { root: true }),
        dispatch('officer/setOfficers', res.data.officers, { root: true }),
        dispatch('document/setDocuments', res.data.documents, { root: true })
      ])
    })
  },
  clearSubmission({ commit }) {
    return new Promise(resolve => {
      commit('SET_SUBMISSION', {})
      resolve()
    })
  },
  clear({ commit }) {
    return new Promise(resolve => {
      commit('SET_SUBMISSION', {})
      commit('SET_SUBMISSIONS', [])
      resolve()
    })
  }
}